<div class="container">
  <section>
    <div class="subSection">
      <div class="left">
        @if (discount.featured) {
          <p class=""><span class="discount-span">Featured Discount</span></p>
        }
        <h4>{{discount.partnerName}} </h4>
        <p class="discount-description" [innerHTML]="discount.offerDescription"></p>
        <div>
          <p class="discount">DISCOUNT</p>
          <div class="price"[innerHTML]="discount.offer"></div>
        </div>
      </div>
      <div class="right">
        <img src="{{discount.partnerLogoUrl}}" alt="{{discount.partnerName}}">
        @if (discount.redemptionMethod === 'url') {
          <button type="button" (click)="openUrl(discount)" class="regular button solid-green">{{discount.redemptionCTA}}</button>
        }
        @if (discount.redemptionMethod === 'code') {
          <button type="button" (click)="showDiscount(discount)"  class="regular button solid-green">{{discount.redemptionCTA}}</button>
        }
      </div>
    </div>
  </section>
</div>
<app-membership-modal
  [modalId]="'modal-promo'"
  [titleCode]="discount.partnerName"
  [buttonText]="'REDEEM NOW'"
  [url]="discount.redemptionUrl"
  [code]="discount.redemptionCode"
[subText]="confirmText"></app-membership-modal>
